<template>
	<nk-page commercialAccess="Salary" class="" :policyClaims="``" tabindex="101" startup>
		<template #badges>
			<nk-badge system="salary">
				<nk-badge-item type="system" modelValue="salary" :title="$t('forms.SalaryPeriods')"></nk-badge-item>
				<nk-badge-item type="edition" :modelValue="settings.mode === FormModes.READONLY ? FormModes.READONLY : (isEmpty(getPeriodId) ? 'new' : 'edit')"></nk-badge-item>
			</nk-badge>
		</template>
		<div class="nk-card form-container" ref="parent">
			<div class="p-5">
				<div class="row  mb-5">
					<div class="col-sm-6 col-md-4 col-lg-4">
						<nk-col-form-group :label="$t('salary.month') + ':'" :labelSizes="{ sm: 12, md: 2 }" :dataSizes="{ sm: 12, md: 10 }" :labelAligns="{ sm: 'right', md: 'left', lg: 'left' }">
							<nk-dropdown ref="selectedMonthDrop" class="form-container" :options="monthOptions.month" v-model="monthValue.selectedMonth" :disabled="!isEmpty(getPeriodId) || !!settings?.selectedMonth?.date" :tabindex="102" :data="months"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-sm-6 col-md-4 col-lg-4">
						<nk-col-form-group :label="$t('salary.type') + ':'" :labelSizes="{ sm: 12, md: 2 }" :dataSizes="{ sm: 12, md: 10 }" :labelAligns="{ sm: 'right', md: 'left', lg: 'left' }">
							<nk-dropdown :disabled="true" class="form-container" :options="monthOptions.type" v-model="monthValue.selectedType" :tabindex="104" :data="types"></nk-dropdown>
						</nk-col-form-group>
					</div>
					<div class="col-sm-12 col-md-4 col-lg-4">
						<nk-col-form-group :label="$t('salary.preview-name') + ':'" :labelSizes="{ sm: 12, md: 4 }" :dataSizes="{ sm: 12, md: 8 }" :labelAligns="{ sm: 'right', md: 'left', lg: 'left' }">
							<nk-input class="" v-model="monthValue.displayName" :options="monthOptions.displayName" :tabindex="106"></nk-input>
						</nk-col-form-group>
					</div>
				</div>
			</div>
		</div>
	</nk-page>
</template>

<script lang="ts">
	import $sc from '@/plugins/shortcut.collection'
	import validators, { Checker, isEmpty, VRequiredIfValue } from '@/statics/validators'
	import { defineComponent } from 'vue'
	import { ConvertedSalaryPeriod, CreateMonth, CreatePeriodOptions, CreatePeriodType, CreatePeriodValue, IStringMap, SelectedPastPeriod, SubPeriod } from '@/classes/salary/salary-period'
	import type { PropType } from 'vue'
	import { post } from '@/plugins/nikan-api'
	import Endpoints from '@nikan/endpoints'
	import { mapActions, mapGetters } from 'vuex'
	import { IResponse } from '@/interfaces/base'
	import { TYPE } from 'vue-toastification'
	import { FormModes } from '@/enums/system'
	import merge from 'lodash/merge'

	export default defineComponent({
		name: "create-period",
		modal: {
			size: 'custom',
			height: 340,
			width: 900,
			stateUID: 'create-period',
			helpTag: 'SalaryPeriodModify'
		},
		props: {
			options: {
				type: Object as PropType<CreatePeriodOptions>,
				required: true
			},
		},
		created() {
			merge(this.settings, this.options)
		},
		mounted() {
			this.getMonths()
			this.formMode()
			this.prepareWindow(this.$t(`salary.${!isEmpty(this.getPeriodId) ? 'modify-month' : 'insert-month'}`), [this.insertBtn, this.insertAndStayBtn])
			this.defer(() => this.$refs.selectedMonthDrop.$el.focus(), 100)
		},
		data() {
			return {
				FormModes: FormModes,
				settings: {} as any,
				types: [{ isMain: false, name: 'مجازی' }, { isMain: true, name: 'اصلی' }] as CreatePeriodType[],
				monthOptions: {
					month: {
						emitNullOnNotFound: true,
					} as any,
					type: {
						emitNullOnNotFound: true
					},
					displayName: {},
				},
				monthValue: {
					selectedMonth: new CreateMonth(),
					selectedType: new CreatePeriodType(),
					selectedPastMonth: new CreateMonth(),
					selectedPastDisplayName: new SelectedPastPeriod(),
					displayName: null,
					tableCopy: false,
					contractCopy: false,
					salaryItemCopy: false,
					copySettings: false,
				} as CreatePeriodValue,
				months: [] as CreateMonth[] | undefined,
				insertBtn: {
					title: this.$t('table.buttons.save'),
					shortcut: $sc.find('save'),
					icon: 'fa-regular fa-save',
					visible: true,
					// policyClaims: () => { or: [`SaleBuy_Factor${this.factorType}_Add`, `SaleBuy_Factor${this.factorType}_Edit`] },
					isPrimary: false,
					handle: async () => {
						if (await this.save()) {
							this.resolve()
						}
					},
					selfButton: true,
				},
				insertAndStayBtn: {
					title: this.$t('save-new'),
					shortcut: $sc.find('insert'),
					icon: 'fa-regular fa-plus',
					visible: true,
					// policyClaims: () => { or: [`SaleBuy_Factor${this.factorType}_Add`, `SaleBuy_Factor${this.factorType}_Edit`] },
					isPrimary: false,
					handle: async () => {
						await this.save()
						this.formMode()
					},
					selfButton: true,
				},
			}
		},
		computed: {
			...mapGetters({
				getFiscalPeriod: 'appContext/getFiscalPeriod',
			}),
			pastMonths() {
				return this.settings?.getMonths().filter((x: any) => x.subPeriods && x.subPeriods.length).map((x: ConvertedSalaryPeriod) => { return { ...x, name: x.pYear + ' ' + x.pMonthName } })
			},
			pastDescriptions() {
				if (this.monthValue.selectedPastMonth)
					return this.monthValue.selectedPastMonth.subPeriods.map((x: SubPeriod, ind: number) => { return { ...x, name: (ind + 1).toString() + '- ' + x.displayName } })
				return []
			},
			getPeriodId() {
				return this.settings.subPeriod && this.settings.subPeriod.id
			}
		},
		watch: {
			'monthValue.selectedMonth': {
				// deep: true,
				handler(val: CreateMonth) {
					this.formMode()
					if (val && isEmpty(this.getPeriodId)) this.monthValue.displayName = this.monthValue.selectedType.name + ' ' + val.pMonthName + ' ' + val.pYear
				}
			},
		},
		methods: {
			isEmpty,
			...mapActions({
				refreshSalaryPeriod: 'salaryPeriods/refresh'
			}),
			getMonths() {
				this.months = this.settings?.getMonths().map((x: ConvertedSalaryPeriod) => {
					return { ...x, name: x.pYear + ' ' + x.pMonthName }
				})
			},
			formMode() {
				if (this.settings?.selectedMonth?.date)
					this.monthValue.selectedMonth = this.months?.find(x => x.date === (this.settings.selectedMonth && this.settings.selectedMonth.date)) as CreateMonth
				if (!isEmpty(this.getPeriodId)) {
					this.monthValue.selectedType = this.types.find((x) => x.isMain === (this.settings.subPeriod && this.settings?.subPeriod.isMain)) as CreatePeriodType
					this.monthValue.displayName = this.settings.subPeriod.displayName
					this.insertAndStayBtn.visible = false
					if (!this.monthValue.selectedType) this.monthValue.selectedType = { isMain: true, name: 'اصلی' }
				} else {
					if (!this.settings?.subPeriod?.isMain && this.monthValue?.selectedMonth?.subPeriods.some((x: SubPeriod) => x.isMain))
						this.monthValue.selectedType = { isMain: false, name: 'مجازی' }
					else
						this.monthValue.selectedType = { isMain: true, name: 'اصلی' }
				}
			},
			save() {
				if (this.validation()) {
					if (this.monthValue.selectedMonth.subPeriods.length < 5 || !isEmpty(this.getPeriodId)) {
						//@ts-ignore
						var wait = this.$wait(this.$el)
						const payLoad: any = {
							"salaryPeriod": {
								"id": this.getPeriodId,
								"fiscalPeriodId": this.getFiscalPeriod.id,
								"date": this.monthValue.selectedMonth.date,
								"isLocked": false,
								"isMain": this.monthValue.selectedType.isMain,
								"displayName": this.monthValue.displayName
							},
							"copyFromSalaryPeriod": {
								"salaryPeriodId": this.monthValue.selectedPastDisplayName.id,
								"copyContracts": this.monthValue.contractCopy,
								"copyContractSalaryItems": this.monthValue.salaryItemCopy,
								"copyAuxiliaryTables": this.monthValue.tableCopy,
								"copySettings": this.monthValue.copySettings
							}
						}
						return post(Endpoints.getUrl(!isEmpty(this.getPeriodId) ? 'salaryPeriod.edit' : 'salaryPeriod.create'), payLoad)
							.then(async (result: IResponse<any>) => {
								this.$toast(this.$t('salary.period-action-successfully', { periodName: this.monthValue.selectedMonth.name + ' ' + this.monthValue.displayName, state: !isEmpty(this.getPeriodId) ? this.$t('salary.edit') : this.$t('salary.create') }), { type: TYPE.SUCCESS })
								await this.refreshSalaryPeriod()
								this.monthValue = new CreatePeriodValue()
								this.getMonths()
								wait.end()
								return true
							})
							.catch(() => {
								wait.end()
								return false
							})
					} else {
						this.$toast(this.$t('salary.period.cant-create-more-than-five-period-in-a-month'))
					}
				}
			},
			validation() {
				const validationObj = {
					displayName: validators('required'),
					selectedMonth: validators('required'),
					selectedType: validators('required'),
					selectedPastDisplayName: validators(new VRequiredIfValue('selectedPastDisplayName', () => !!this.monthValue.selectedPastMonth
					)),
				}
				let checker = new Checker((key: string) => {
					const messages: IStringMap = {
						displayName: this.$t('salary.validation.messages.displayName'),
						selectedMonth: this.$t('salary.validation.messages.selectedMonth'),
						selectedType: this.$t('salary.validation.messages.selectedType'),
						selectedPastDisplayName: this.$t('salary.validation.messages.selectedPastDisplayName'),
					}
					return messages[key]
				})
				let errors = checker.test(this.monthValue, validationObj)
				//@ts-ignore
				this.validationToast(errors)
				return errors.length === 0
			}
		}
	})
</script>

<style scoped></style>